module.exports = __webpack_public_path__ + "static/bg2-ca97993d9fd4641d70fa205152f597f3.png";